import React, { useCallback, useMemo, useRef, useState } from 'react';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import Form, { SimpleItem as Item, GroupItem, ButtonItem, Label, RangeRule, RequiredRule } from 'devextreme-react/form';
import handlePostBudget from '../../../Utils/handlePOST/handlePostBudget';
import handlePutBudget from '../../../Utils/handlePUT/handlePutBudget';
import handleDelBudget from '../../../Utils/handleDEL/handleDelBudget';
import useGetBudget from '../../../Hooks/useGET/useGetBudget';
import useHandleWorkCenter from '../../../Hooks/useHandleData/useHandleWorkCenter';
import { isMobile } from '../../../Utils/media-query';
import { checkRoles } from '../../../Utils/helper';
import useFetch from '../../../Hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import "devextreme/ui/drop_down_box";
import './componets.css';
import ShowTotalBudget from './showTotalBudget';
/*
-=-=-=-=-=-=-=-=-=-=-=-= To-do -=-=-=-=-=-=-=-=-=-=-=-=
=-= [ ] move material budget closer together
-=- [x] material are added are removed together
=-= [~] validate data before sending
-=- [~] push data to backend
=-= [ ] allow editing by only allowed
-=- [ ] allow deleting by a few
*/
//we must! change the loading animations
const indicatorUrl = "https://js.devexpress.com/Content/data/loadingIcons/rolling.svg";
export default function BudgetFormPopup({ onClose, data, setNotification, }) {
    console.log('budget data', data)
    const billingCode = data.row.key;
    const
        navigate = useNavigate(),
        fetch = useFetch(navigate);

    const {
        operationBudget: operationHours,
        researchBudget: researchHours,
        materialBudget: materialCost,
        allTotalBudgets,
        isLoading,
        mutate } = useGetBudget(billingCode)
    const
        [operationBudget, setOperationBudget] = useState(null),
        [researchBudget, setResearchBudget] = useState(null),
        [materialBudget, setMaterialBudget] = useState(null);

    const workTasks = useHandleWorkCenter()?.workCenters
   
    if (!isLoading && operationBudget === null) {
        setOperationBudget(operationHours || [{
            id: null,
            projectedHours: null,
        }]);
    }
    if (!isLoading && researchBudget === null) {
        setResearchBudget(researchHours || [{
            id: null,
            projectedHours: null,
        }]);
    }
    if (!isLoading && materialBudget === null) {
        setMaterialBudget(materialCost || [{
            id: null,
            name: '',
            cost: null,
        }]);
    }

    const isBudgetEmpty = !operationHours && !researchHours && !materialCost;

    const formData = useMemo(() => ({
        operationBudget,
        researchBudget,
        materialBudget,
    }), [operationBudget, researchBudget, materialBudget]);

    const formRef = useRef(null);

    const cancelBtnOptions = useCallback(() => {
        return {
            text: 'Cancel',
            onClick: onClose,
        }
    }, [onClose]);

    /*
    =-=-=-=-=-=-=-=-=-=- save/confirm button -=-=-=-=-=-=-=-=-=-=
    */
    const handleSave = useCallback(async () => {
        let formValidation = formRef.current.instance.validate();
        if (formValidation.isValid) {
            // Changes the put or post depending if the the form is an add or edit
            const handleBudget = isBudgetEmpty ? handlePostBudget : handlePutBudget
            const { response, isDataGood } = await handleBudget(fetch, operationBudget, researchBudget, materialBudget, billingCode);
            console.log(response, isDataGood)
            setNotification(response);
            mutate();
            if (isDataGood) onClose();
        }

    }, [fetch, operationBudget, researchBudget, materialBudget, onClose, billingCode, setNotification, isBudgetEmpty, mutate]);

    const confirmBtnOptions = useCallback(() => {
        return {
            useSubmitBehavior: true,
            text: isBudgetEmpty ? 'Save' : 'Edit',
            onClick: () => handleSave()
        }
    }, [isBudgetEmpty, handleSave]);

    /*
        =-=-=-=-=-=-=-=-=-=- delete button -=-=-=-=-=-=-=-=-=-=
    */
    const handleDelete = useCallback(() => {
        const { response } = handleDelBudget(fetch, operationBudget, researchBudget, materialBudget, billingCode);

        setNotification(response);

    }, [fetch, operationBudget, researchBudget, materialBudget, setNotification, billingCode])

    const deleteBtnOptions = useCallback(() => {
        return {
            stylingMode: 'contained',
            type: 'danger',
            text: 'Delete entire budget',
            onClick: () => handleDelete()
        }
    }, [handleDelete]);

    const generateNewHoursOptions = useCallback((index, state, setState) => ({
        buttons: [
            {
                name: 'trash',
                location: 'after',
                options: {
                    stylingMode: 'text',
                    icon: 'trash',
                    onClick: () => {
                        const newState = state.slice(0, index).concat(state.slice(index + 1));
                        setState(newState);
                    }
                }

            }
        ]
    }), []);

    const workTasksOpt = {
        items: workTasks,
        valueExpr: 'id',
        displayExpr: 'name',
        searchEnabled: true
    }

    /* 
        =-=-=-=-=-=-=-=-=-=- all operations options -=-=-=-=-=-=-=-=-=-=
    */
    const OperationOptions = useMemo(() => {
        let options = [];
        for (let i = 0; i < operationBudget?.length; i++) {
            options.push(generateNewHoursOptions(i, operationBudget, setOperationBudget));
        }
        return options
    }, [operationBudget, generateNewHoursOptions])

    const OperationButtonOptions = useMemo(() => ({
        icon: 'add',
        text: 'Add Operation Hours',
        onClick: () => {
            setOperationBudget((prevHours) => [
                ...prevHours,
                {
                    id: null,
                    projectedHours: null
                }
            ])
        }
    }), [operationBudget]);

    /* 
        =-=-=-=-=-=-=-=-=-=- all research options -=-=-=-=-=-=-=-=-=-=
    */
    const ResearchOptions = useMemo(() => {
        let options = [];
        for (let i = 0; i < researchBudget?.length; i++) {
            options.push(generateNewHoursOptions(i, researchBudget, setResearchBudget));
        }
        return options
    }, [researchBudget, generateNewHoursOptions])

    const ResearchButtonOptions = useMemo(() => ({
        icon: 'add',
        text: 'Add Research Hours',
        onClick: () => {
            setResearchBudget((prevHours) => [
                ...prevHours,
                {
                    id: null,
                    projectedHours: null
                }
            ])
        }
    }), [researchBudget]);

    /* 
        =-=-=-=-=-=-=-=-=-=- all material options -=-=-=-=-=-=-=-=-=-=
    */
    const MaterialOptions = useMemo(() => {
        let options = [];
        for (let i = 0; i < materialBudget?.length; i++) {
            options.push(generateNewHoursOptions(i, materialBudget, setMaterialBudget));
        }
        return options
    }, [materialBudget, generateNewHoursOptions])

    const MaterialButtonOptions = useMemo(() => ({
        icon: 'add',
        text: 'Add Material',
        onClick: () => {
            setMaterialBudget((prevHours) => [
                ...prevHours,
                {
                    id: materialBudget.length + 1,
                    name: '',
                    cost: null,
                }
            ])
        }
    }), [materialBudget]);

    return (
        <>
            <Popup
                dragEnabled={false}
                title={'Budget'}
                fullscreen={isMobile}
                showTitle={true}
                visible={true}
                width='auto'
                height='85%'>

                <ToolbarItem
                    visible={isBudgetEmpty || checkRoles(6)}
                    widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    options={confirmBtnOptions()}>
                    {/*<LoadIndicator*/}
                    {/*    visible={checkLoading}*/}
                    {/*    indicatorSrc={indicatorUrl} /> */}
                </ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    options={cancelBtnOptions()}
                />
                {/*<ToolbarItem*/}
                {/*    visible={!isBudgetEmpty && checkRoles(6)}*/}
                {/*    widget="dxButton"*/}
                {/*    location="before"*/}
                {/*    toolbar="bottom"*/}
                {/*    options={deleteBtnOptions()}*/}
                {/*/>*/}
                {isLoading ?
                    <LoadIndicator visible={true} indicatorSrc={indicatorUrl} /> :
                    <>
                        {!isBudgetEmpty && <ShowTotalBudget budget={allTotalBudgets} />}
                        <Form
                            colCount={4}
                            id='form'
                            readOnly={!isBudgetEmpty && !checkRoles(6)}
                            formData={formData}
                            ref={formRef}
                            showValidationSummary={true}>

                            <GroupItem
                                caption='Operation Budget'
                                colSpan={4} >
                                {OperationOptions?.map((hours, index) => (
                                    <GroupItem
                                        colSpan={2}
                                        colCount={2}
                                    >
                                        <Item
                                            key={`OperationTask${index}`}
                                            dataField={`operationBudget[${index}].id`}
                                            editorOptions={workTasksOpt}
                                            editorType="dxSelectBox"
                                            isRequired={true} >
                                            <Label text={`Task ${index + 1}`} />
                                            <RequiredRule />
                                        </Item>
                                        <Item
                                            key={`Operation${index}`}
                                            dataField={`operationBudget[${index}].projectedHours`}
                                            editorOptions={hours}
                                            editorType="dxNumberBox"
                                            isRequired={true} >
                                            <Label text={`Operation Hours ${index + 1}`} />
                                            <RequiredRule />
                                            <RangeRule min={.0001} message='Hours must be greater than 0' />
                                        </Item>
                                    </GroupItem>
                                ))}
                                <ButtonItem
                                    horizontalAlignment="left"
                                    buttonOptions={OperationButtonOptions}>
                                </ButtonItem>
                            </GroupItem>

                            <GroupItem
                                caption='Research Budget'
                                colSpan={4} >
                                {ResearchOptions.map((hours, index) => (
                                    <GroupItem
                                        colSpan={2}
                                        colCount={2}
                                    >
                                        <Item
                                            key={`ResearchTask${index}`}
                                            dataField={`researchBudget[${index}].id`}
                                            editorOptions={workTasksOpt}
                                            editorType="dxSelectBox"
                                            isRequired={true} >
                                            <Label text={`Task ${index + 1}`} />
                                            <RequiredRule />
                                        </Item>
                                        <Item
                                            key={`Research${index}`}
                                            dataField={`researchBudget[${index}].projectedHours`}
                                            editorOptions={hours}
                                            editorType="dxNumberBox"
                                            isRequired={true} >
                                            <RequiredRule />
                                            <RangeRule min={.0001} message='Hours must be greater than 0' />
                                            <Label text={`Research Hours ${index + 1}`} />
                                        </Item>
                                    </GroupItem>
                                ))}
                                <ButtonItem
                                    horizontalAlignment="left"
                                    buttonOptions={ResearchButtonOptions}>
                                </ButtonItem>
                            </GroupItem>

                            <GroupItem
                                caption='Material Budget'
                                colSpan={4}
                            >
                                {MaterialOptions.map((hours, index) => (
                                    <GroupItem
                                        key={`Material${index}`}
                                        colSpan={2}
                                        colCount={2}>
                                        <Item
                                            dataField={`materialBudget[${index}].name`}
                                            isRequired={true} >
                                            <Label text={`Name ${index + 1}`} />
                                        </Item>
                                        <Item
                                            dataField={`materialBudget[${index}].cost`}
                                            editorOptions={hours}
                                            editorType="dxNumberBox"
                                            isRequired={true} >
                                            <Label text={`Cost ${index + 1}`} />
                                            <RequiredRule />
                                            <RangeRule min={.0001} message='Hours must be greater than 0' />
                                        </Item>
                                    </GroupItem>
                                ))}
                                <ButtonItem
                                    horizontalAlignment="right"
                                    buttonOptions={MaterialButtonOptions}>
                                </ButtonItem>
                            </GroupItem>
                        </Form>
                    </>
                }
            </Popup >
        </>
    )
}

